import { defineStore } from 'pinia'
import { getContentPage } from '@/services/contentService'

export const useLeadershipStore = defineStore('leadership', {
  state: () => ({
    contents: {
      leadership: {},
      ourLeader: {},
      leaderships: [],
    },
    loading: false,
    error: null
  }),

  actions: {
    async fetchContentPage() {
      this.loading = true
      this.error = null

      try {
        const baseUploadURL = process.env.VUE_APP_API_URL;
        const leadershipContent = await getContentPage('Leadership', 'Leadership')
        const ourLeaderContent = await getContentPage('Leadership', 'Contents')
        const leadershipList = await getContentPage('Home', 'Item Leadership')

        const mapOurLeader = await Promise.all(
          ourLeaderContent.map(async item => ({
            ...item,
            thumbnails: item.banner
              ? baseUploadURL + item.banner.uploadFile
              : null,
          }))
        )

        const mapLeadershipList = await Promise.all(
          leadershipList.map(async item => ({
            ...item,
            image: item.banner
              ? baseUploadURL + item.banner.uploadFile
              : null,
          }))
        )

        this.contents.leadership = leadershipContent.length > 0 ? leadershipContent[0] : null
        this.contents.ourLeader = mapOurLeader.length > 0 ? mapOurLeader[0] : null
        this.contents.leaderships = mapLeadershipList

        console.log(this.contents.ourLeader)
        // console.log(this.contents.vision)
        // console.log(this.contents.mission)
        // console.log(this.contents.project)
        // console.log(this.contents.services)
        // console.log(this.contents.thinker)
        // console.log(this.contents.safety)
        // console.log(this.contents.leadership)
        // console.log(this.contents.news)
        // console.log(this.contents.ourClient)
        // console.log(this.contents.banners)
        // console.log(this.contents.leaderships)
        // console.log(this.contents.projects)
        // // console.log(projectList)
        // console.log(this.contents.newsList)
        // console.log(this.contents.clients)
        // console.log(this.contents.contacts)
      } catch (err) {
        this.error = err.message
      } finally {
        this.loading = false
      }
    }
  }
})